import { RootState } from "@/modules/common";

export const selectProductStatus = (state: RootState) => state.products.status;
